import { Link } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import TextEditor from 'views/pages/TextEditor'
import Hints from 'views/pages/UIElements/Hints'
import 'react-toastify/dist/ReactToastify.css'
import './styles/styles.css'
import { useDispatch, useSelector } from 'react-redux'
// import AxiosInstance from 'utils/AxiosInstance'
import { useEffect } from 'react'
import {
  present,
  fetchZoom,
  toggleDisclaimerPage,
  toggleGdprPage,
  toggleWelcomeEmail,
  setPdfViewer,
  onChangeDashboardType,
  enableUserRewardsOnDashboard,
  enableLeaderBoardOnDashboard,
  enableCorporateHierarchy,
  enableManagerAlertOnDashboard,
  onChangeLink,
  toggleSecondLink,
  toggleFirstLink,
  toggleThirdLink,
  onChangeContactEmail,
  onChangeCertificateType,
  saveGeneralSettings,
  undo,
  enableComboardNotifications,
  enablePdfjsDownloadAndPrint,
} from 'store/ConfigurationSettings/GeneralConfig/actions'
import { Input } from 'reactstrap'
import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'

// Leon global Style
import '../../../../assets/css/Global/style.css'
import Select from 'views/pages/Select'
import { setMessagesArchivePeriod } from 'store/ConfigurationSettings/GeneralConfig/actions'
import { allowSignup } from 'store/ConfigurationSettings/GeneralConfig/actions'
import { askCountryAge } from 'store/ConfigurationSettings/GeneralConfig/actions'
import { askCountry } from 'store/ConfigurationSettings/GeneralConfig/actions'
import { askAge } from 'store/ConfigurationSettings/GeneralConfig/actions'
import { enableCertificateFooter } from 'store/ConfigurationSettings/GeneralConfig/actions'
import { onChangeTextCertificateFooter } from 'store/ConfigurationSettings/GeneralConfig/actions'
import { enablePublicCatalogPercentage } from 'store/ConfigurationSettings/GeneralConfig/actions'
import { allowAllLocationsAccess } from 'store/ConfigurationSettings/GeneralConfig/actions'
import { enableLanguageFiles } from 'store/ConfigurationSettings/GeneralConfig/actions'
import { autoCompleteForms } from 'store/ConfigurationSettings/GeneralConfig/actions'
import { disableLocationForms } from 'store/ConfigurationSettings/GeneralConfig/actions'

// const ExternalApps = (props) => {
// 	const apps = Object.keys(props).length
// 		? [
// 				{
// 					id: 1,
// 					label: 'Zoom',
// 					hint: 'Enables for you to create zoom meetings for courses.',
// 					value:
// 						props.zoom && props.zoom.authorize_url
// 							? props.zoom.authorize_url
// 							: null,
// 					buttonValue:
// 						(props.zoom && !props.zoom.has_authorized
// 							? 'Authorize'
// 							: 'Deauthorize') + ' Zoom',
// 					buttonStyle: {
// 						backgroundColor:
// 							props.zoom && !props.zoom.has_authorized ? '#2486e6' : '#d04a3b',
// 						padding: '0.375rem 0.75rem',
// 						fontSize: '0.875rem',
// 						border: 'none',
// 					},
// 					buttonIcon: 'fa fa-video',
// 					otherFunction: async () => {
// 						await AxiosInstance.delete('/settings/zoomAuth')
// 							.then((data) => {
// 								props.fetchZoom()
// 							})
// 							.catch((err) => {
// 								console.log('error', err)
// 							})
// 					},
// 				},
// 		  ]
// 		: []

// 	return (
// 		<div className='modules-options'>
// 			<h3>External Apps</h3>
// 			{apps.length > 0
// 				? apps.map((app, index) => (
// 						<div className='config-row' key={index}>
// 							<div className='with-hint item'>
// 								<span>{app.label}</span>
// 								<Hints message={app.hint} />
// 							</div>
// 							<a
// 								target='_blank'
// 								href={app.value}
// 								onClick={
// 									!app.value
// 										? () => {
// 												app.otherFunction()
// 										  }
// 										: null
// 								}
// 								className='btn btn-default btn-info'
// 								style={app.buttonStyle}
// 								rel='noreferrer'
// 							>
// 								<i className={app.buttonIcon}></i> {app.buttonValue}
// 							</a>
// 						</div>
// 				  ))
// 				: null}
// 		</div>
// 	)
// }

const ExternalLinks = (props) => {
  const dispatch = useDispatch()
  const generalConfig = props.generalConfig
  const language = useSelector((state) => state.language.language?.data)
  // console.log('props external', props)
  const links = [
    {
      id: 1,
      label: `${language?.general.first_link || ''}`,
      value: generalConfig.firstLink,
      showLink: generalConfig.showFirstLink,
      toggleLink: toggleFirstLink,
    },
    {
      id: 2,
      label: `${language?.general.second_link || ''}`,
      value: generalConfig.secondLink,
      showLink: generalConfig.showSecondLink,
      toggleLink: toggleSecondLink,
    },
    {
      id: 3,
      label: `${language?.general.third_link || ''}`,
      value: generalConfig.thirdLink,
      showLink: generalConfig.showThirdLink,
      toggleLink: toggleThirdLink,
    },
  ]

  return (
    <div className='modules-options'>
      <h3>{language?.settings.external_links}</h3>
      {links &&
        links.map((link, index) => (
          <div className='dFlex itemsCenter justifyBetween p-2 ' key={index}>
            <div className='with-hint item'>
              <span>{link.label}</span>
              <Hints message={language?.hints.show_link_main_menu} />
            </div>
            {link.showLink ? (
              <form onSubmit={props.onSaveLink}>
                <div className='language-change-input-row'>
                  <Input
                    type='text'
                    placeholder='Name'
                    name='name'
                    value={link.value.name || ''}
                    size={'sm'}
                    // className={link.id}
                    onChange={() => dispatch(onChangeLink())}
                  />
                </div>
                <div className='language-change-input-row'>
                  <Input
                    type='text'
                    placeholder='Insert URL'
                    name='URL'
                    value={link.value.URL || ''}
                    // className={link.id}
                    size={'sm'}
                    onChange={() => dispatch(onChangeLink())}
                  />
                </div>
              </form>
            ) : null}
            <label
              style={{ minWidth: '52px' }}
              className={`custom-toggle ${link.showLink ? ' active' : ''}`}
            >
              <input
                checked={link.showLink || false}
                onChange={() => dispatch(link.toggleLink(!link.showLink))}
                // defaultChecked
                type='checkbox'
                style={{ display: 'none' }}
              />
              <span className='custom-toggle-slider rounded-circle' />
            </label>
          </div>
        ))}
    </div>
  )
}

const GeneralConfig = (props) => {
  const dispatch = useDispatch()
  const language = useSelector((state) => state.language.language?.data)
  const generalConfig = props.generalConfig

  useEffect(() => {
    // dispatch(fetchgeneralConfig());
    dispatch(present())
    dispatch(fetchZoom())
  }, [dispatch])

  const saveSettings = () => {
    dispatch(saveGeneralSettings())
      .then(() => {
        toast.success(
          language?.alerts?.settings_saved_succesfully ||
            'Settings saved successfully!',
          {
            position: toast.POSITION.TOP_CENTER,
            className: 'general-settings-toast',
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: 'light',
          }
        )
      })
      .catch(() => {
        toast.error(
          language?.alerts?.failed_to_save_settings ||
            'Failed to save settings.',
          {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: 'general-settings-toast',
            autoClose: 4000,
          }
        )
      })
  }

  const handleSave = () => {
    // event.preventDefault(); // Prevent default form submission
    saveSettings() // Call the saveSettings function
  }

  return (
    <div className='tab-content'>
      <div className='modules-options '>
        <h3>{language?.settings.disclaimer}</h3>

        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className='with-hint item'>
            <span>{language?.settings.turn_on_disclaimer}</span>
            <Hints message={language?.hints.disclaimer} />
          </div>
          <label className='custom-toggle' style={{ minWidth: '52px' }}>
            <input
              checked={generalConfig.disclaimerShowing || false}
              onChange={() =>
                dispatch(toggleDisclaimerPage(!generalConfig.disclaimerShowing))
              }
              defaultChecked
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
      </div>

      {generalConfig.disclaimerShowing ? (
        <TextEditor
          textContent={generalConfig.disclaimerContent}
          // onChangeText={() => dispatch(onChangeText())}
          // onImageUpload={()=>dispatch(onImageUpload())}
          setOptions={{
            buttonList: [
              ['undo', 'redo', 'fontSize', 'formatBlock', 'list'],
              ['bold', 'underline', 'italic'],
              ['image', 'link'],
            ],
          }}
        />
      ) : null}

      <div className='modules-options'>
        <h3>{language?.settings.gdpr_message}</h3>

        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className='with-hint item'>
            <span>{language?.settings.show_gdpr}</span>
            <Hints message={language?.hints.gdpr} />
          </div>
          <label
            style={{ minWidth: '52px' }}
            className={`custom-toggle ${
              generalConfig.showGdpr ? ' active' : ''
            }`}
          >
            <input
              checked={generalConfig.showGdpr || false}
              onChange={() => dispatch(toggleGdprPage(!generalConfig.showGdpr))}
              defaultChecked
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
      </div>
      {generalConfig.showGdpr ? (
        <TextEditor
          textContent={generalConfig.gdprContent}
          onChangeText={props.onChangeTextGdpr}
          onImageUpload={props.onImageUpload}
          autoFocus={true}
          setOptions={{
            buttonList: [
              ['undo', 'redo', 'fontSize', 'formatBlock', 'list'],
              ['bold', 'underline', 'italic'],
              ['image', 'link'],
            ],
          }}
        />
      ) : null}

      <div className='modules-options'>
        <h3>{language?.settings.welcome_email}</h3>
        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className='with-hint item'>
            <span>{language?.settings.auto_send_welcome_email}</span>
            <Hints message={language?.hints.welcome_email_new_users} />
          </div>
          <label
            style={{ minWidth: '52px' }}
            className={`custom-toggle ${
              generalConfig.sendWelcomeEmail ? ' active' : ''
            }`}
          >
            <input
              checked={generalConfig.sendWelcomeEmail || false}
              onChange={() =>
                dispatch(toggleWelcomeEmail(!generalConfig.sendWelcomeEmail))
              }
              defaultChecked
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
      </div>

      <div className='modules-options'>
        <h3>{language?.settings.document_viewer}</h3>
        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className=''>
            <span>{language?.settings.google_viewer}</span>
            <Hints message={language?.hints.document_viewer} />
          </div>
          <input
            type='radio'
            className='custom-radio-button'
            name='modules-pdf-viewer-options'
            id='google-viewer-option'
            checked={generalConfig.pdfViewer === 'google' && true}
            onChange={(type) => dispatch(setPdfViewer('google'))}
          />
          <label htmlFor='google-viewer-option' className='config-item'></label>
        </div>
        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className=''>
            <span>{language?.settings.pdf_only_viewer}</span>
            <Hints message={language?.hints.pdf_only_viewer} />
          </div>
          <input
            type='radio'
            className='custom-radio-button'
            name='modules-pdf-viewer-options'
            id='pdf-viewer-option'
            checked={generalConfig.pdfViewer === 'pdfjs' && true}
            onChange={(type) => dispatch(setPdfViewer('pdfjs'))}
          />
          <label htmlFor='pdf-viewer-option' className='config-item'></label>
        </div>
      </div>

      <div className='modules-options'>
        <h3>{language?.settings.dashboard}</h3>
        <div className='dFlex itemsCenter justifyBetween p-2'>
          <div className='with-hint item'>
            <span>{language?.settings.dashboard_1}</span>
            <Hints
              message={
                language?.settings.select_dashboard +
                ' ' +
                language?.settings.dashboard_1_desc
              }
            />
          </div>
          <input
            type='radio'
            className='custom-radio-button'
            name='dashboard-type'
            id='dashboard-type-1'
            checked={generalConfig.dashboardType === 1}
            onChange={() => dispatch(onChangeDashboardType(1))}
            style={{ marginLeft: '5px' }}
          />
          <label htmlFor='dashboard-type-1' className='config-item' />
        </div>
        <div className='dFlex itemsCenter justifyBetween p-2'>
          <div className='with-hint item'>
            <span>{language?.settings.dashboard_2}</span>
            <Hints
              message={
                language?.settings.select_dashboard +
                ' ' +
                language?.settings.dashboard_2_desc
              }
            />
          </div>
          <input
            type='radio'
            className='custom-radio-button'
            name='dashboard-type'
            id='dashboard-type-2'
            checked={generalConfig.dashboardType === 2}
            onChange={() => dispatch(onChangeDashboardType(2))}
            style={{ marginLeft: '5px' }}
          />
          <label htmlFor='dashboard-type-2' className='config-item' />
        </div>
        {/* <div className='config-row'>
						<div className='with-hint item'>
							<span>Allow rewards</span>
							<Hints
								message={
									language.settings
										? language.settings.select_dashboard +
										  ' ' +
										  language.settings.dashboard_1_desc
										: null
								}
							/>
						</div>
						{console.log(props, 'props')}
						<input
							type='radio'
							className='custom-radio-button'
							name='dashboard-type'
							id='dashboard-type-1'
							checked={props.userRewardsOnDashboard}
							onClick={() => console.log('notclickable')}
							style={{ marginLeft: '5px' }}
						/>
						<label htmlFor='dashboard-type-1' className='config-item' />
					</div> */}
        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className='with-hint item'>
            <span>Enable Rewards in dashboard</span>
            <Hints
              message={
                language?.hints
                  ? 'Allows user to see his rewards on dashboard'
                  : null
              }
            />
          </div>
          <label
            style={{ minWidth: '52px' }}
            className={`custom-toggle ${
              generalConfig.userRewardsOnDashboard ? ' active' : ''
            }`}
          >
            <input
              checked={generalConfig.userRewardsOnDashboard || false}
              onChange={() =>
                dispatch(
                  enableUserRewardsOnDashboard(
                    !generalConfig.userRewardsOnDashboard
                  )
                )
              }
              defaultChecked
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className='with-hint item'>
            <span>Enable Leaderboard in dashboard</span>
            <Hints
              message={
                language?.hints
                  ? 'Allows to see the leaderboard table on dashboard'
                  : null
              }
            />
          </div>
          <label
            style={{ minWidth: '52px' }}
            className={`custom-toggle ${
              generalConfig.leaderBoardOnDashboard ? ' active' : ''
            }`}
          >
            <input
              checked={generalConfig.leaderBoardOnDashboard || false}
              onChange={() => dispatch(enableLeaderBoardOnDashboard())}
              defaultChecked
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className='with-hint item'>
            <span>Enable manager alert in dashboard</span>
            <Hints
              message={
                language?.hints
                  ? 'Allows to see the leaderboard table on dashboard'
                  : null
              }
            />
          </div>
          <label
            style={{ minWidth: '52px' }}
            className={`custom-toggle ${
              generalConfig.managerAlertOnDashboard ? ' active' : ''
            }`}
          >
            <input
              checked={generalConfig.managerAlertOnDashboard || false}
              onChange={() => dispatch(enableManagerAlertOnDashboard())}
              defaultChecked
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
      </div>
      <div className='modules-options'>
        <h3>{language?.general.manager_report}</h3>
        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className='with-hint item'>
            <span>Enable Corporate Hierarchy Users</span>
            <Hints
              message={
                language?.hints
                  ? 'Enables hierarchy on manager report Corporate Users'
                  : null
              }
            />
          </div>
          <label
            style={{ minWidth: '52px' }}
            className={`custom-toggle ${
              generalConfig.corporateHierarchy ? ' active' : ''
            }`}
          >
            <input
              checked={generalConfig.corporateHierarchy || false}
              onChange={() => dispatch(enableCorporateHierarchy())}
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className='with-hint item'>
            <span>Enable in progress percentage in public catalog</span>
            <Hints
              message={
                'Enables exact course percentage progress in public catalog reports. (finished courses / total contents) * 100'
              }
            />
          </div>
          <label
            style={{ minWidth: '52px' }}
            className={`custom-toggle ${
              generalConfig.publicCatalogPercentage ? ' active' : ''
            }`}
          >
            <input
              checked={generalConfig.publicCatalogPercentage || false}
              onChange={() => dispatch(enablePublicCatalogPercentage())}
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>

        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className='with-hint item'>
            <span>Allow all location access for restaurant progress</span>
            <Hints
              message={
                'Allows managers to see data for all locations in the restaurant progress dashboard widget, even if theyre not assigned.'
              }
            />
          </div>
          <label
            style={{ minWidth: '52px' }}
            className={`custom-toggle ${
              generalConfig.allowAllLocationsAccess ? ' active' : ''
            }`}
          >
            <input
              checked={generalConfig.allowAllLocationsAccess || false}
              onChange={() => dispatch(allowAllLocationsAccess())}
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
      </div>

      <div className='modules-options'>
        <h3>{language?.settings.certificate_templates}</h3>
        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className=''>
            <span>{language?.settings.certificate_template_1}</span>
            <Hints message={language?.general.choose_1} />
          </div>
          <input
            type='radio'
            className='custom-radio-button'
            name='certificate-type'
            id='certificate-type-1'
            checked={generalConfig.certificateType === 1}
            onChange={() => dispatch(onChangeCertificateType(1))}
            style={{ marginLeft: '5px' }}
          />
          <label htmlFor='certificate-type-1' className='config-item' />
        </div>
        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className=''>
            <span>{language?.settings.certificate_template_2}</span>
            <Hints message={language?.general.choose_2} />
          </div>
          <input
            type='radio'
            className='custom-radio-button'
            name='certificate-type'
            id='certificate-type-2'
            checked={generalConfig.certificateType === 2}
            onChange={() => dispatch(onChangeCertificateType(2))}
            style={{ marginLeft: '5px' }}
          />
          <label htmlFor='certificate-type-2' className='config-item' />
        </div>

        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className=''>
            <span>Certificate Footer</span>
            <Hints message={language?.general.choose_1} />
          </div>
          <label
            style={{ minWidth: '52px' }}
            className={`custom-toggle ${
              generalConfig.certificateFooter ? ' active' : ''
            }`}
          >
            <input
              checked={generalConfig.certificateFooter || false}
              onChange={() => dispatch(enableCertificateFooter())}
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        {console.log(props, 'leart633')}
        {generalConfig.certificateFooter && (
          <div className='mb-2'>
            <TextEditor
              textContent={generalConfig.certificateFooterContent}
              onChangeText={(e) => dispatch(onChangeTextCertificateFooter(e))}
              autoFocus={true}
              setOptions={{
                buttonList: [
                  ['undo', 'redo', 'fontSize', 'formatBlock', 'list'],
                  ['bold', 'underline', 'italic'],
                ],
              }}
            />
          </div>
        )}
      </div>
      <div className='modules-options'>
        <h3>{language?.general.contact_email}</h3>
        <div className=''>
          <div className='dFlex itemsCenter justifyBetween p-2 '>
            <div>
              <span>{language?.general.automatic_email}</span>
              <Hints message={language?.general.change_automatic_email} />
            </div>
            <div className='language-change-input-row'>
              <Input
                type='text'
                placeholder={`${
                  language?.general.contact_email || 'Contact Email'
                }`}
                name='contact-email'
                size={'sm'}
                value={generalConfig.contactEmail || ''}
                onChange={() => dispatch(onChangeContactEmail())}
              />
            </div>
          </div>
        </div>
      </div>

      <div className='modules-options'>
        <h3>Messages</h3>
        <div className=''>
          <div className='dFlex itemsCenter justifyBetween p-2 '>
            <div>
              <span>Messages will be archived after:</span>
              <Hints
                message={
                  'Choose a period after which messages will be archived'
                }
              />
            </div>
            <div>
              <Select
                options={[
                  { name: '1 month', value: '1 m' },
                  { name: '6 months', value: '6 m' },
                  { name: '1 year', value: '1 y' },
                ]}
                onChange={(e) => {
                  dispatch(setMessagesArchivePeriod(e.option))
                }}
                placeholder={generalConfig.messagesArchivePeriod.name}
                selectedOption={generalConfig.messagesArchivePeriod}
              />
            </div>
          </div>
        </div>
      </div>

      <ExternalLinks {...props} generalConfig={generalConfig} />

      <div className='modules-options'>
        <h3>Other Settings</h3>

        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className='with-hint item'>
            <span>Download & Print buttons on PDFjs</span>
            <Hints
              message={
                language?.settings.hints
                  ? 'Enables Download & Print buttons on pdfjs'
                  : null
              }
            />
          </div>
          <label
            style={{ minWidth: '52px' }}
            className={`custom-toggle ${
              generalConfig.pdfjsDownloadAndPrint ? ' active' : ''
            }`}
          >
            <input
              checked={generalConfig.pdfjsDownloadAndPrint || false}
              onChange={() => dispatch(enablePdfjsDownloadAndPrint())}
              defaultChecked
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>

        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className='with-hint item'>
            <span>Communication Board Notifications</span>
            <Hints
              message={
                language?.settings.hints
                  ? 'Enables Communication Board Notifications'
                  : null
              }
            />
          </div>
          <label
            style={{ minWidth: '52px' }}
            className={`custom-toggle ${
              generalConfig.comboardNotifications ? ' active' : ''
            }`}
          >
            <input
              checked={generalConfig.comboardNotifications || false}
              onChange={() => dispatch(enableComboardNotifications())}
              defaultChecked
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>

        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className='with-hint item'>
            <span>Allow signup</span>
            <Hints message={'Allow users to create their own accounts.'} />
          </div>
          <label
            style={{ minWidth: '52px' }}
            className={`custom-toggle ${
              generalConfig.allowSignup ? ' active' : ''
            }`}
          >
            <input
              checked={generalConfig.allowSignup || false}
              onChange={() => dispatch(allowSignup())}
              defaultChecked
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>

        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className='with-hint item'>
            <span>Ask for country signing up</span>
            <Hints message={'Ask for country when signing up'} />
          </div>
          <label
            style={{ minWidth: '52px' }}
            className={`custom-toggle ${
              generalConfig.askCountry ? ' active' : ''
            }`}
          >
            <input
              checked={generalConfig.askCountry || false}
              onChange={() => dispatch(askCountry())}
              defaultChecked
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>

        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className='with-hint item'>
            <span>Ask for age when signing up</span>
            <Hints message={'Ask for  age when signing up'} />
          </div>
          <label
            style={{ minWidth: '52px' }}
            className={`custom-toggle ${generalConfig.askAge ? ' active' : ''}`}
          >
            <input
              checked={generalConfig.askAge || false}
              onChange={() => dispatch(askAge())}
              defaultChecked
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>

        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className='with-hint item'>
            <span>Language specific files in My Library</span>
            <Hints message={'Enable language specific files in My Library'} />
          </div>
          <label
            style={{ minWidth: '52px' }}
            className={`custom-toggle ${
              generalConfig.enableLanguageFiles ? ' active' : ''
            }`}
          >
            <input
              checked={generalConfig.enableLanguageFiles || false}
              onChange={() => dispatch(enableLanguageFiles())}
              defaultChecked
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>

        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className='with-hint item'>
            <span>Auto complete forms on submission</span>
            <Hints
              message={
                'Automatically marks a form submission as Done when it is submitted.'
              }
            />
          </div>
          <label
            style={{ minWidth: '52px' }}
            className={`custom-toggle ${
              generalConfig.autoCompleteForms ? ' active' : ''
            }`}
          >
            <input
              checked={generalConfig.autoCompleteForms || false}
              onChange={() => dispatch(autoCompleteForms())}
              defaultChecked
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>

        <div className='dFlex itemsCenter justifyBetween p-2 '>
          <div className='with-hint item'>
            <span>Disable location in forms</span>
            <Hints
              message={
                'When enabled, forms will not ask users to select a location when filling them out, and the Location column is hidden from submissions.'
              }
            />
          </div>
          <label
            style={{ minWidth: '52px' }}
            className={`custom-toggle ${
              generalConfig.disableLocationForms ? ' active' : ''
            }`}
          >
            <input
              checked={generalConfig.disableLocationForms || false}
              onChange={() => dispatch(disableLocationForms())}
              defaultChecked
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
      </div>
      <div className='col my-4' style={{ marginTop: '40px', marginLeft: '0' }}>
        <SubmitModalButton
          text={language?.general?.save || 'Save'}
          customFn={handleSave}
        />
        <Link to='/dashboard'>
          <CancelModalButton
            text={language?.general?.cancel || 'Cancel'}
            customFn={() => dispatch(undo())}
          />
        </Link>
      </div>
      <ToastContainer />
    </div>
  )
}

export default GeneralConfig
